import { render } from "./DashboardCreateTop.vue?vue&type=template&id=6661cbec"
import script from "./DashboardCreateTop.vue?vue&type=script&lang=js"
export * from "./DashboardCreateTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__